import React from "react";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
import useApplicantProfile from "./useApplicantProfile";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

export default (props) => {
  const { userProfileInfo } = useApplicantProfile(props);
  return (
    <Container>
      <div className="applicant-profile row h-100">
        {userProfileInfo?.summary && userProfileInfo?.cover_letter !== null ? (
          <div className="col-12 mb-4">
            <div className="custom-card rounded-lg">
              <div className="card-header border-bottom-0">
                <h3>Applicant Summary</h3>
              </div>
              {/* candidate skills to be shown here */}
              <div className="card-body bg-white d-flex justify-content-between align-items-start">
                <p className="d-flex align-items-center flex-wrap">
                  {userProfileInfo?.summary}
                </p>
                <a
                  href={userProfileInfo?.cover_letter}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Cover Letter
                </a>
              </div>
            </div>
          </div>
        ) : null}

        <div className="col-12 mb-4 bg-white border-radius-10 border">
          <div className="custom-card rounded-lg pt-3">
            <h3>Top 5 Skills</h3>
            {/* candidate skills to be shown here */}
            <div className="mt-2">
              <ul className="d-flex align-items-center flex-wrap">
                {Array.isArray(
                  userProfileInfo?.candidate_profile_details?.skills
                ) &&
                  userProfileInfo?.candidate_profile_details?.skills && userProfileInfo.candidate_profile_details.skills.length ? (
                  Array.isArray(
                    userProfileInfo?.candidate_profile_details?.skills
                  ) &&
                  userProfileInfo?.candidate_profile_details?.skills && userProfileInfo.candidate_profile_details.skills.map(
                    (item) => (
                      <li className="bg-grey-3 rounded h4 font-weight-normal px-2 py-1 mr-2 text-capitalize">
                        {item.skill_name}
                      </li>
                    )
                  )
                ) : (
                  <p className="font-weight-medium">Not Available</p>
                )}
              </ul>
            </div>
          </div>
          <div className="custom-card rounded-lg mt-4">
            <h3>General Information</h3>
            <div className="bg-white">
              <div className="row">
                <div className="col-lg-6 col-xl-4">
                  <p className="mb-0 font-weight-medium mt-3 text-grey-4">
                    Name
                  </p>
                  <p className="font-weight-medium text-capitalize">
                    {userProfileInfo?.candidate_details &&
                      userProfileInfo.candidate_details?.full_name}
                  </p>
                </div>
                {userProfileInfo?.candidate_profile_details &&
                  userProfileInfo.candidate_profile_details?.dob &&
                  <div className="col-lg-4">
                    <p className="mb-0 font-weight-medium text-grey-4">
                      Date of Birth
                    </p>
                    <p className="font-weight-medium">
                      { userProfileInfo?.candidate_profile_details &&
                        userProfileInfo.candidate_profile_details?.dob}
                    </p>
                  </div>
                }
                {userProfileInfo.candidate_profile_details &&
                  userProfileInfo.candidate_profile_details.gender &&
                  <div className="col-lg-4">
                    <p className="font-weight-medium text-grey-4 mb-1">Gender</p>
                    <p className="font-weight-medium text-capitalize">
                      {userProfileInfo.candidate_profile_details &&
                        userProfileInfo.candidate_profile_details.gender}
                    </p>
                  </div>
                }
                {(userProfileInfo?.job_details &&
                  userProfileInfo.job_details.application_form_address ===
                  "mandatory") ||
                  (userProfileInfo?.job_details &&
                    userProfileInfo.job_details.application_form_address ===
                    "optional") ? (
                  <div
                    className={`col-lg-4 ${userProfileInfo.candidate_profile_details?.city_name
                      ? "d-block"
                      : "d-none"
                      }`}
                  >
                    <div className="mb-0 font-weight-medium text-grey-4">
                      <p className="mb-1">Location</p>
                      <p className="font-weight-medium text-dark-2 text-capitalize">
                        {userProfileInfo?.candidate_profile_details &&
                          userProfileInfo.candidate_profile_details?.city_name}
                        ,
                        {userProfileInfo?.candidate_profile_details &&
                          userProfileInfo.candidate_profile_details
                            ?.country_name &&
                          userProfileInfo.candidate_profile_details
                            .country_name}
                      </p>
                    </div>
                  </div>
                ) : null}
                <div className="col-lg-6 col-xl-4">
                  {userProfileInfo?.candidate_profile_details &&
                    userProfileInfo.candidate_profile_details
                      ?.candidate_website &&
                    Array.isArray(
                      userProfileInfo.candidate_profile_details.candidate_website
                    ) &&
                    userProfileInfo.candidate_profile_details.candidate_website
                      .length ? (
                    <>
                      <p className="mb-0 font-weight-medium">Website</p>
                      <p className="font-weight-medium">
                        <a
                          href={
                            userProfileInfo?.candidate_profile_details &&
                            userProfileInfo.candidate_profile_details
                              ?.candidate_website
                          }
                          className="text-grey-4"
                        >
                          {userProfileInfo?.candidate_profile_details &&
                            userProfileInfo.candidate_profile_details
                              ?.candidate_website}
                        </a>
                      </p>
                    </>
                  ) : null}
                </div>
                <div className="col-lg-6 col-xl-4">
                  {userProfileInfo.candidate_profile_details &&
                    Array.isArray(
                      userProfileInfo.candidate_profile_details.portfolio
                    ) &&
                    userProfileInfo.candidate_profile_details.portfolio.length ? (
                    <>
                      <p className="mb-0 font-weight-medium">Portfolio</p>
                      <p className="font-weight-medium text-grey-4 mb-0 d-flex flex-column">
                        {Array.isArray(
                          userProfileInfo.candidate_profile_details.portfolio
                        ) &&
                          userProfileInfo.candidate_profile_details.portfolio.map(
                            (item) => (
                              <a
                                target="_blank"
                                href={item?.portfolio_url}
                                className="text-grey-4"
                              >
                                {item?.portfolio_url}
                              </a>
                            )
                          )}
                      </p>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {(userProfileInfo?.job_details &&
            userProfileInfo.job_details.application_form_experience_required ===
            "mandatory") ||
            (userProfileInfo?.job_details &&
              userProfileInfo.job_details.application_form_experience_required ===
              "optional") ? (
            <div className="profession col-12 px-0 my-4">
              <div className="custom-card">
                <h3>Professional Information</h3>
                <div className="mt-1">
                  <ul className="info-list text-capitalize">
                    {Array.isArray(userProfileInfo.candidate_work_experience) &&
                      userProfileInfo.candidate_work_experience.length ? (
                      Array.isArray(
                        userProfileInfo.candidate_work_experience
                      ) &&
                      userProfileInfo.candidate_work_experience?.map((data) => (
                        <li className="mt-3 border rounded-lg p-3 ">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h3 className="font-weight-medium mb-1 text-uppercase">
                                {data?.job_title}
                              </h3>
                              <p className="text-capitalize mb-1 d-inline-block mr-3 text-grey-4 fs-14">
                                {data?.company_name}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex fs-14">
                            <span className="text-capitalize mb-1 text-grey-4">
                              {data?.employment_type.replace(/_/g, "-")} {"|"}{" "}
                            </span>
                            <p className="text-grey-4 mb-1">
                              {dateFormatter(data?.start_date)} -{" "}
                              {data?.currently_working_here === true
                                ? "currently working here"
                                : dateFormatter(data?.end_date)}
                            </p>
                          </div>
                          <ul className="d-flex align-items-center flex-wrap mt-2">
                            {data?.skill_names &&
                              Array.isArray(data.skill_names) &&
                              data.skill_names.map((item) => (
                                <li className="bg-grey-3 rounded h4 font-weight-normal px-2 py-1 mr-2 text-capitalize">
                                  {item}
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))
                    ) : (
                      <p className="font-weight-medium   p-4 rounded-lg border">
                        Not Available
                      </p>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          ) : null}

          {(userProfileInfo?.job_details &&
            userProfileInfo.job_details.application_form_education_required ===
            "mandatory") ||
            (userProfileInfo?.job_details &&
              userProfileInfo.job_details.application_form_education_required ===
              "optional") ? (
            <div className="education col-12 px-0 mb-4 ">
              <div className="custom-card">
                <h3>Educational Information</h3>
                <div className="mt-1">
                  <ul className="info-list">
                    {userProfileInfo.candidate_education.length ? (
                      Array.isArray(userProfileInfo.candidate_education) &&
                      userProfileInfo.candidate_education?.map((data) => (
                        <li className="mt-3 p-3  border rounded-lg">
                          <h3 className="mb-1 font-weight-medium">
                            {data?.school_name &&
                              data.school_name.toUpperCase()}
                          </h3>

                          <p className="mb-1 text-uppercase  text-grey-4 fs-14">
                            {data?.college_degree_name}
                          </p>
                          <div className="d-flex text-grey-4 fs-14">
                            {data?.field_of_study_name ? (
                              <p className="mb-1 text-capitalize">
                                {data?.field_of_study_name}
                              </p>
                            ) : null}
                            <p className="text-grey-4">
                              {" "}
                              {"|"} {dateFormatter(data?.start_date)} -{" "}
                              {dateFormatter(data?.end_date)}
                            </p>
                          </div>
                        </li>
                      ))
                    ) : (
                      <p className="font-weight-medium   p-4 rounded-lg border">
                        Not Available
                      </p>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Container>
  );
};
